var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinexArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FCFBCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.901 12L12 16.974V36H36V16.974L33.099 12H32.3333H14.901ZM16.4323 14.6667H31.5677L33.1224 17.3333H14.8776L16.4323 14.6667ZM20 20H28V22.6667H20V20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinexArchive);
export default __webpack_public_path__ + "static/media/coinex-archive.916fb71858ed4e4eb32f15363ea41eff.svg";
export { ForwardRef as ReactComponent };